let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdvHb")).then(() => parcelRequire('ac080'));